import { NewTooltip } from '@lib/components'
import { Pin } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import css from './styles.module.css'

interface Props {
  pinned?: boolean
}

// Shows why a card sits at the top of the list. Pinning itself is done from the
// "…" menu: the card is a <Link> whose click handling already has to tell its
// own clicks from the menu's, and a second control inside it would join that.
export const PinMarker: React.FC<Props> = ({ pinned = false }) => {
  if (!pinned) {
    return null
  }

  return (
    <NewTooltip
      content={<span className={css.tooltip_content}>Pinned to top</span>}
      renderEl={(onSetRef, onMouseEnter, onMouseLeave) => (
        <div
          ref={onSetRef}
          className={css.icon_wrap}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Pin />
        </div>
      )}
    />
  )
}
